/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog, IconButton, breakpoints } from '@coursera/cds-core';

import Header from 'bundles/authentication-common/components/Header';

import _t from 'i18n!nls/authentication';

const { Content } = Dialog;

type Props = {
  preventModalClose?: boolean;
  isOpen: boolean;
  onClose?: () => void;
  contentLabel?: string;
  children: React.ReactNode;
};

const styles = {
  dialog: css`
    .cds-Dialog-dialog {
      width: auto;
      border-radius: var(--cds-border-radius-200);
      max-height: 100%;
      min-height: auto;

      [data-testid='scroll-container'] {
        position: relative;
      }

      @media (max-width: 600px) {
        width: 100%;
        height: 100%;
      }

      ${breakpoints.down('xs')} {
        border-radius: 0;
      }
    }
  `,
  contentContainer: css`
    width: 424px;
    padding: var(--cds-spacing-300);

    @media (max-width: 600px) {
      padding: 48px 0 0;
    }

    ${breakpoints.down('xs')} {
      width: 100%;
    }
  `,
  closeBtn: css`
    border-radius: 50%;
    position: fixed;
    right: 12px;
    top: 8px;
    z-index: 10;

    @media (min-width: 600px) {
      position: absolute;
    }
  `,
};

const Modal = ({
  children,
  preventModalClose = false,
  contentLabel = _t('Authentication Modal'),
  isOpen,
  onClose,
}: Props) => {
  return (
    <Dialog
      css={styles.dialog}
      open={isOpen}
      onClose={onClose}
      width="medium"
      variant="transactional"
      aria-label={contentLabel}
      role="dialog"
    >
      <Header />

      {!preventModalClose && (
        <IconButton
          css={styles.closeBtn}
          intent="close"
          variant="ghostSecondary"
          size="small"
          onClick={onClose}
          aria-label={_t('Close modal')}
          data-e2e="close-modal-button"
        />
      )}
      <Content css={styles.contentContainer}>{children}</Content>
    </Dialog>
  );
};

export default Modal;
